<ion-header class="ion-header-verify-code">
  <ion-toolbar>
    <div class="header-grid">
      <div class="main-logo-sec">
        <img src="assets/images/eZintegration-black-logo.svg">
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="container">
    <div class="bg-grid">
      <div class="grid-container">
        <div class="grid-content">
          <div class="company-logo-sec">
            <img src="assets/images/bizdata-header-logo.png">
          </div>
          <div class="main-logo-sec">
              <img src="assets/images/eZintegration-black-logo.svg">
          </div>
          <span class="bg-sub-content"> Verify your Identity </span>
          <mat-card>
            <mat-card-content>
              <div class="views-content">
                  <span class="content-1"> You are trying to login to eZintegrations. </span>
                  <span class="content-1"> To make sure eZintegrations account is secure, we have to verify your identity. </span>
              </div>
              <div class="views-content">
                <span class="content-1"> Enter the verification code we emailed to </span>
                <span class="content-1"><strong>{{verifyemail}}</strong></span>
            </div>
            <div class="form-container">
              <form [formGroup]="verifyCodeform" (ngSubmit)="onVerifyCodeSubmit()">
                <mat-form-field appearance="outline">
                  <mat-label>Verification Code</mat-label>
                  <input type="text" formControlName="verifyCode" matInput placeholder="Verification Code" required>
                  <!-- <mat-error *ngIf="submitted && verifyCodeControls.verifyCode.hasError('required')">Verification Code Required. </mat-error> -->
                </mat-form-field>
                <div class="verify-links">
                  <!-- <mat-checkbox formControlName="checkVerify">Don't ask again</mat-checkbox> -->
                  <a class="verify-link" href="javascript:void" (click)="resendVerifyCode()">Resend Code</a>
                </div>
                <div class="btn-grid">
                  <button mat-raised-button type="submit" class="btn-verify">Verify</button>
                </div>
              </form>
            </div>
            </mat-card-content>
          </mat-card>
        </div>
        <app-powered-by-footer></app-powered-by-footer>
      </div>
    </div>
  </div>
</ion-content>
